var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6844 3.87293C20.6844 3.87293 20.2902 7.87233 22 13.4179C22 13.4179 19.5725 19.2575 12 22C4.42773 19.2565 2 13.4155 2 13.4155C3.71074 7.87433 3.31582 3.88031 3.31582 3.88031C7.13184 2.22701 12 2 12 2C12 2 16.8682 2.21883 20.6844 3.87293Z",
    fill: "#CBCCCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.6fd1d399ab554eb2369a4d3b48889a3f.svg";
export { ForwardRef as ReactComponent };